import { combineReducers, configureStore } from '@reduxjs/toolkit';

import usersReducer, { initUserFromToken } from '../features/User/userSlice';
import certificateReducer from '../features/Certificates/certificatesSlice';
import logorequestListReducer from '../features/LogoRequestList/logoRequestSlice';
import { LoggedInUserDefaultData } from '../features/User/user.types';

const preloadedState = {
  users: {
    loginUser: LoggedInUserDefaultData,
    users: [],
    sites: [],
    loading: false,
    error: null,
  }
}

const rootReducer = combineReducers({
    users: usersReducer,
    certificates: certificateReducer,
    logorequestList : logorequestListReducer
    // add more slices here
});
  

export const store = configureStore({
    reducer: rootReducer,
    preloadedState
});

store.dispatch(initUserFromToken());

// For useSelector and useDispatch with types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;